export default __webpack_public_path__ + "static/media/bv-login-template-bg.f9765ca1.jpg";